import LogRocket from 'logrocket';
import template from './zoomFocus.html';

/* @ngInject */
function ZoomFocusController(CameraService, growl) {
  const vm = this;

  // //////////////// //
  // PUBLIC VARIABLES //
  // //////////////// //


  // //////////////// //
  // PUBLIC FUNCTIONS //
  // //////////////// //
  vm.$onInit = init;
  vm.setZoom = setZoom;
  vm.setFocus = setFocus;
  vm.setAutoFocus = setAutoFocus;

  function init() {
    getZoomAndFocus(vm.camId)
      .then(({ data }) => {
        vm.zoom = parseFloat(data.zoom);
        vm.focus = parseFloat(data.focus);
        vm.autoFocus = data.autofocus;
      });
  }

  function setZoom() {
    vm.savingZoom = true;
    let growlMessage = growl.info('Setting zoom...', {
      disableCloseButton: true
    });
    CameraService.setZoom(vm.camId, vm.zoom)
      .then(() => {
        vm.savingZoom = false;
        growlMessage.destroy();
        growlMessage = growl.success('Zoom set successfully!');
      })
      .catch((res) => {
        vm.savingZoom = false;
        growlMessage.destroy();
        const error = 'Error setting zoom';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  // Set Camera Focus
  function setFocus() {
    vm.savingFocus = true;
    let growlMessage = growl.info('Setting focus...', {
      disableCloseButton: true
    });
    CameraService.setFocus(vm.camId, vm.focus)
      .then(() => {
        vm.savingFocus = false;
        growlMessage.destroy();
        growlMessage = growl.success('Focus set successfully!');
      })
      .catch((res) => {
        vm.savingFocus = false;
        growlMessage.destroy();
        const error = 'Error setting focus';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }


  function setAutoFocus() {
    let growlMessage;
    growlMessage = vm.autoFocus === 'off' ? growl.info('Disabling auto-focus', {
      disableCloseButton: true
    }) : growl.info('Enabling auto-focus', {
      disableCloseButton: true
    });
    CameraService.setAutoFocus(vm.camId, vm.autoFocus)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Auto-Focus setting successfully changed.');
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error setting Auto-Focus';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  // Get the zoom and focus of the current camera...
  function getZoomAndFocus(id) {
    return CameraService.getZoomFocus(id)
      .then(data => data);
  }
}

export default {
  name: 'zoomFocus',
  template,
  controllerAs: 'ZoomFocusCtrl',
  controller: ZoomFocusController,
  bindings: {
    camId: '<',
    zoom: '<?'
  }
};
